import { Flex, Switch, Text } from "@coaching-culture/ui";
import React from "react";
import { SpaceProps } from "styled-system";

export type ToggleProps = {
  value: boolean;
  onChange: (val: boolean) => void;
  leftLabel: string;
  rightLabel: string;
  /** Name for screen readers; defaults to the right label (the "on" side). */
  ariaLabel?: string;
} & SpaceProps;

/** An either/or switch with a label on each side. Clicking a label picks it. */
export function Toggle({
  value,
  onChange,
  rightLabel,
  leftLabel,
  ariaLabel,
  ...rest
}: ToggleProps) {
  return (
    <Flex alignItems={"center"} {...rest}>
      <Text
        mr={2}
        color={value ? "grey1" : "body"}
        fontWeight={600}
        style={{ cursor: "pointer", userSelect: "none" }}
        onClick={() => onChange(false)}
      >
        {leftLabel}
      </Text>
      <Switch
        value={value}
        onChange={onChange}
        aria-label={ariaLabel ?? rightLabel}
      />
      <Text
        ml={2}
        color={!value ? "grey1" : "body"}
        fontWeight={600}
        style={{ cursor: "pointer", userSelect: "none" }}
        onClick={() => onChange(true)}
      >
        {rightLabel}
      </Text>
    </Flex>
  );
}
